import React from 'react';
import { motion } from 'framer-motion';

const stats = [
  { value: '10+', label: 'Years of making' },
  { value: '120', label: 'Homes transformed' },
  { value: '38', label: 'Design awards' },
  { value: '01', label: 'Personal approach' }
];

function StatsSection() {
  return (
    <section className="stats-section section-wrap">
      <div className="stats-grid">
        {stats.map((s, i) => (
          <motion.div
            key={s.label}
            className="stat-item"
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 0.5, delay: i * 0.1 }}
          >
            <strong>{s.value}</strong>
            <span>{s.label}</span>
          </motion.div>
        ))}
      </div>
    </section>
  );
}

export default StatsSection;
